/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE. 
*/

import { ReactNode, cloneElement } from "react";

export type WrapProps = {
	children: ReactNode;
	condition: boolean;
	wrap: (children: ReactNode) => React.JSX.Element;
};

export const Wrap = ({ condition, children, wrap }: WrapProps): React.JSX.Element =>
	condition ? cloneElement(wrap(children)) : <>{children}</>;
